import React, { PropsWithChildren } from 'react'
import { Box, Icon, Box as IconBox, type IconName } from '@node-space/ui-components'

export interface IconListItem {
  iconName: IconName
  text: string
}

export interface IconListItemProps extends PropsWithChildren {
  items: IconListItem[]
  className?: string
}

export const IconList = ({ items, className }: IconListItemProps) => {
  return (
    <Box flexCol paddingT={24} gap={12} {...(className && { className })}>
      {items?.map(({ iconName, text }) => (
        <Box key={iconName} flex gap={8} align="center">
          <IconBox
            flex
            centerChildren
            size={32}
            borderRadius="full"
            className="text-foreground-action-secondary bg-surface-interactive"
            flexSize="keep"
          >
            <Icon name={iconName} />
          </IconBox>
          <p className="text-body-regular-large text-foreground-subdued">{text}</p>
        </Box>
      ))}
    </Box>
  )
}
